import { FaArrowLeft } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RiLogoutCircleRLine, RiChatHistoryLine } from "react-icons/ri";
import { BiCapsule } from "react-icons/bi";
import languageContext from "../context/language/languageContext";
import { useContext } from "react";
import { FaNotesMedical } from "react-icons/fa";

const Navbar = () => {
  const {
    setChats,
    setbookappointment,
    checklist,
    setchecklist,
    bookappointment,
    setIsLeftPanel,
    isLeftPanel,
    labbook,
    labsetbook,
    sessionTimeout,
    isRightPanel,
    setIsRightPanel,
  } = useContext(languageContext);

  const navigate = useNavigate();
  const location = useLocation();
  const url = location.state?.url || "/"; // fallback if no URL in state

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("login");
    navigate("/");
  };

  const handleBackArrowPress = () => {
    navigate(-1);
  };

  const handleBookAppointment = () => {
    navigate("/account");
  };

  const handleMedicineChatbot = () => {
    navigate("/medicine_chat");
  };

  const handlehome = () => {
    navigate("/ask");
  };

  // ✅ NEW: Patient Details handler for Nurse Dashboard
  const handlePatientDetails = () => {
    navigate("/patient-details"); // 🔑 Replace with your actual route
  };

  return (
    <div className="bg-bgcolor w-full h-[80px] flex items-center justify-between shadow-md px-4">
      <div className="flex">
        {!localStorage.getItem("login") ? (
          <div
            className="w-[40px] h-[40px] bg-white rounded-full flex justify-center items-center ml-2 cursor-pointer shadow"
            onClick={handleBackArrowPress}
          >
            <FaArrowLeft />
          </div>
        ) : (
          <>
            <div
              className="w-[40px] h-[40px] bg-white rounded-full flex justify-center items-center ml-2 cursor-pointer shadow"
              onClick={handleBackArrowPress}
            >
              <FaArrowLeft />
            </div>
            {!location.pathname.includes("/medicine_chat") && (
              <div
                className="w-[40px] h-[40px] bg-white rounded-full flex justify-center items-center ml-2 cursor-pointer shadow"
                onClick={() => {
                  setIsRightPanel(false);
                  setIsLeftPanel(!isLeftPanel);
                }}
              >
                <RiChatHistoryLine />
              </div>
            )}
          </>
        )}
      </div>

      <div className="flex items-center">
        {(location.pathname.includes("/account") ||
          location.pathname.includes("/ask") ||
          location.pathname.includes("/medicine_chat") ||
          location.pathname.includes("/patient_summary_note") ||
          location.pathname.includes("/patient-details")||
          location.pathname.includes("/chat_history")||
          location.pathname.includes("/view_lab_test")||
          location.pathname.includes("/view_appointment")||
          location.pathname.includes("/view_reminder")||
          location.pathname.includes("/chat_summary")||
          location.pathname.includes("/prescription_history")||

          location.pathname.includes("/nurse")) && (
          <>
            <button
              onClick={handlehome}
              className="bg-slate-200 ml-2 rounded-lg px-3 py-2 flex items-center gap-2 hover:bg-slate-300 transition"
            >
              Home
            </button>

            <button
              onClick={handleBookAppointment}
              className="bg-slate-200 ml-2 rounded-lg px-3 py-2 flex items-center gap-2 hover:bg-slate-300 transition"
            >
              Profile
            </button>

            <button
              onClick={handleMedicineChatbot}
              className="bg-slate-200 ml-2 rounded-lg px-3 py-2 flex items-center gap-2 hover:bg-slate-300 transition"
            >
              <BiCapsule className="text-sky-700" size={18} />
              Medicine Info
            </button>

            {/* {!location.pathname.includes("/patient_summary_note") && (
              <button
                onClick={() => navigate("/patient_summary_note")}
                className="bg-indigo-100 ml-2 rounded-lg px-3 py-2 flex items-center gap-2 hover:bg-indigo-200 transition"
              >
                <FaNotesMedical className="text-indigo-700" size={18} />
                Patient Summary
              </button>
            )} */}

            {/* ✅ NEW Patient Details button for nurse dashboard */}
            {!location.pathname.includes("/patient-details") && (
              <button
                onClick={handlePatientDetails}
                className="bg-green-100 ml-2 rounded-lg px-3 py-2 flex items-center gap-2 hover:bg-green-200 transition"
              >
                <FaNotesMedical className="text-green-700" size={18} />
                Patient Details
              </button>
            )}
          </>
        )}

        {!location.pathname.includes("/login") && (
          <div
            className="w-[40px] h-[40px] bg-white rounded-full flex justify-center items-center ml-4 cursor-pointer shadow"
            onClick={logout}
          >
            <RiLogoutCircleRLine size="1.2rem" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
